var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs, _g, _rect, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAhpLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 159.2 39.5",
    style: {
      enableBackground: "new 0 0 159.2 39.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003E7E;}\n\t.st1{clip-path:url(#SVGID_2_);}\n\t.st2{fill:#26337A;}\n\t.st3{fill:#26347B;}\n\t.st4{fill:#26357C;}\n\t.st5{fill:#27367C;}\n\t.st6{fill:#27377D;}\n\t.st7{fill:#27387E;}\n\t.st8{fill:#27397F;}\n\t.st9{fill:#273A80;}\n\t.st10{fill:#273B81;}\n\t.st11{fill:#283C81;}\n\t.st12{fill:#283D82;}\n\t.st13{fill:#283E83;}\n\t.st14{fill:#283F84;}\n\t.st15{fill:#284085;}\n\t.st16{fill:#284185;}\n\t.st17{fill:#294286;}\n\t.st18{fill:#294387;}\n\t.st19{fill:#294488;}\n\t.st20{fill:#294589;}\n\t.st21{fill:#294689;}\n\t.st22{fill:#29478A;}\n\t.st23{fill:#2A488B;}\n\t.st24{fill:#2A498C;}\n\t.st25{fill:#2A4A8D;}\n\t.st26{fill:#2A4B8E;}\n\t.st27{fill:#2A4C8E;}\n\t.st28{fill:#2A4D8F;}\n\t.st29{fill:#2B4E90;}\n\t.st30{fill:#2B4F91;}\n\t.st31{fill:#2B5092;}\n\t.st32{fill:#2B5192;}\n\t.st33{fill:#2B5293;}\n\t.st34{fill:#2B5394;}\n\t.st35{fill:#2C5495;}\n\t.st36{fill:#2C5596;}\n\t.st37{fill:#2C5697;}\n\t.st38{fill:#2C5797;}\n\t.st39{fill:#2C5898;}\n\t.st40{fill:#2D5999;}\n\t.st41{fill:#2D5A9A;}\n\t.st42{fill:#2D5B9B;}\n\t.st43{fill:#2D5C9B;}\n\t.st44{fill:#2D5D9C;}\n\t.st45{fill:#2D5E9D;}\n\t.st46{fill:#2E5F9E;}\n\t.st47{fill:#2E609F;}\n\t.st48{fill:#2E619F;}\n\t.st49{fill:#2E62A0;}\n\t.st50{fill:#2E63A1;}\n\t.st51{fill:#2E64A2;}\n\t.st52{fill:#2F65A3;}\n\t.st53{fill:#2F66A4;}\n\t.st54{fill:#2F67A4;}\n\t.st55{fill:#2F68A5;}\n\t.st56{fill:#2F69A6;}\n\t.st57{fill:#2F6AA7;}\n\t.st58{fill:#306BA8;}\n\t.st59{fill:#306CA8;}\n\t.st60{fill:#306DA9;}\n\t.st61{fill:#306EAA;}\n\t.st62{fill:#306FAB;}\n\t.st63{fill:#3070AC;}\n\t.st64{fill:#3171AC;}\n\t.st65{fill:#3172AD;}\n\t.st66{fill:#3173AE;}\n\t.st67{fill:#3174AF;}\n\t.st68{fill:#3175B0;}\n\t.st69{fill:#3176B1;}\n\t.st70{fill:#3277B1;}\n\t.st71{fill:#3278B2;}\n\t.st72{fill:#3279B3;}\n\t.st73{fill:#327AB4;}\n\t.st74{fill:#327BB5;}\n\t.st75{fill:#337CB5;}\n\t.st76{fill:#337DB6;}\n\t.st77{fill:#337EB7;}\n\t.st78{fill:#337FB8;}\n\t.st79{fill:#3380B9;}\n\t.st80{fill:#3381BA;}\n\t.st81{fill:#3482BA;}\n\t.st82{fill:#3483BB;}\n\t.st83{fill:#3484BC;}\n\t.st84{fill:#3485BD;}\n\t.st85{fill:#3486BE;}\n\t.st86{fill:#3487BE;}\n\t.st87{fill:#3588BF;}\n\t.st88{fill:#3589C0;}\n\t.st89{fill:#358AC1;}\n\t.st90{fill:#358BC2;}\n\t.st91{fill:#358CC2;}\n\t.st92{fill:#358DC3;}\n\t.st93{fill:#368EC4;}\n\t.st94{fill:#368FC5;}\n\t.st95{fill:#3690C6;}\n\t.st96{fill:#3691C7;}\n\t.st97{fill:#3692C7;}\n\t.st98{fill:#3693C8;}\n\t.st99{fill:#3794C9;}\n\t.st100{fill:#3795CA;}\n\t.st101{fill:#3796CB;}\n\t.st102{fill:#3797CB;}\n\t.st103{fill:#3798CC;}\n\t.st104{fill:#3799CD;}\n\t.st105{fill:#389ACE;}\n\t.st106{fill:#389BCF;}\n\t.st107{fill:#389CCF;}\n\t.st108{fill:#389DD0;}\n\t.st109{fill:#389ED1;}\n\t.st110{fill:#399FD2;}\n\t.st111{fill:#39A0D3;}\n\t.st112{fill:#39A1D4;}\n\t.st113{fill:#39A2D4;}\n\t.st114{fill:#39A3D5;}\n\t.st115{fill:#39A4D6;}\n\t.st116{fill:#3AA5D7;}\n\t.st117{fill:#3AA6D8;}\n\t.st118{fill:#3AA7D8;}\n\t.st119{fill:#3AA8D9;}\n\t.st120{fill:#3AA9DA;}\n\t.st121{fill:#3AAADB;}\n\t.st122{fill:#3BABDC;}\n\t.st123{fill:#3BACDD;}\n\t.st124{fill:#3BADDD;}\n\t.st125{fill:#3BAEDE;}\n\t.st126{fill:#3BAFDF;}\n\t.st127{fill:#3BB0E0;}\n\t.st128{fill:#3CB1E1;}\n\t.st129{fill:#3CB2E1;}\n\t.st130{fill:#3CB3E2;}\n\t.st131{fill:#3CB4E3;}\n\t.st132{fill:#3CB5E4;}\n\t.st133{fill:#3CB6E5;}\n\t.st134{fill:#3DB7E5;}\n\t.st135{fill:#3DB8E6;}\n\t.st136{fill:#3DB9E7;}\n\t.st137{fill:#3DBAE8;}\n\t.st138{fill:#3DBBE9;}\n\t.st139{fill:#3DBCEA;}\n\t.st140{fill:#3EBDEA;}\n\t.st141{fill:#3EBEEB;}\n\t.st142{fill:#3EBFEC;}\n\t.st143{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,12.1l-0.4,1c-0.1,0.2-0.2,0.5-0.2,0.7c0,0.4,0.4,0.4,0.8,0.5v0.2h-2.2v-0.2c0.5-0.1,0.8-0.3,1.1-1.1 l2.5-5.9h0.2l2.4,5.7c0.3,0.6,0.5,1.2,1.2,1.3v0.2h-2.7v-0.2c0.5,0,0.7-0.1,0.7-0.5c0-0.2-0.2-0.6-0.3-0.8l-0.4-0.9H45.6z M46.9,8.9 l-1.2,2.8h2.4L46.9,8.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.3,10.1L52.3,10.1l0,3.4c0,0.7,0,0.9,0.7,0.9v0.1h-1.8v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2 c0-0.6-0.1-0.9-0.7-0.9V9.2h1.5l1.9,4.1l1.9-4.1h1.5v0.1c-0.7,0-0.7,0.2-0.7,0.9v3.2c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1 c0.7,0,0.7-0.2,0.7-0.9v-3.4h0l-2,4.4h-0.1L52.3,10.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.7,11.6h1.1c0.6,0,0.9-0.1,0.9-0.8h0.1v1.8h-0.1c-0.1-0.7-0.3-0.8-0.9-0.8h-1.1v1.9c0,0.3,0.1,0.4,0.4,0.4 h1.1c0.7,0,0.9-0.3,1.4-1h0.2l-0.4,1.3h-4.1v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9V9.2h4l0.1,1.1h-0.2 C62,9.6,61.8,9.5,61,9.5h-1.3V11.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.8,14.5L65.1,12h-0.5v1.4c0,0.7,0,0.9,0.7,0.9v0.1H63v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9 V9.2h2.3c1.5,0,1.8,0.9,1.8,1.4c0,0.8-0.6,1.2-1.3,1.3l1,1.4c0.4,0.5,0.7,0.9,1.4,1v0.1H66.8z M64.5,11.8h0.2c0.7,0,1.5-0.3,1.5-1.1 c0-0.6-0.4-1.1-1.1-1.1c-0.2,0-0.4,0-0.6,0.1V11.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.8,13.5c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9V9.2h2.2v0.1 c-0.7,0-0.7,0.2-0.7,0.9V13.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.6,10.9h-0.1c-0.2-0.9-0.8-1.5-1.8-1.5c-1.1,0-1.8,0.8-1.8,2.6c0,1.8,1.1,2.3,2,2.3c0.8,0,1.3-0.4,1.7-1.1 l0.1,0.1c-0.5,0.9-1.1,1.3-2.2,1.3c-1.5,0-2.5-1.2-2.5-2.6c0-1.5,1.1-2.8,2.7-2.8c0.4,0,0.7,0.1,1.1,0.3c0.1,0,0.2,0.1,0.2,0.1 c0.2,0,0.3-0.2,0.3-0.4h0.1L75.6,10.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.6,12.7l-0.3,0.7c-0.1,0.1-0.2,0.4-0.2,0.5c0,0.3,0.3,0.3,0.6,0.3v0.1h-1.6v-0.1c0.4,0,0.6-0.2,0.8-0.8 l1.9-4.4H79l1.8,4.3c0.2,0.5,0.3,0.9,0.9,0.9v0.1h-2.1v-0.1c0.3,0,0.5-0.1,0.5-0.4c0-0.2-0.1-0.4-0.2-0.6l-0.3-0.7H77.6z M78.7,10.3 l-0.9,2.1h1.8L78.7,10.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83,13.5c0,0.7,0,0.9,0.7,0.9v0.1h-1.8v-0.1c0.7,0,0.7-0.2,0.7-0.9V9.9c-0.3-0.4-0.5-0.5-1-0.5V9.2h1.4l3.2,3.9 h0v-2.9c0-0.7,0-0.9-0.7-0.9V9.2h1.8v0.1c-0.7,0-0.7,0.2-0.7,0.9v4.3h-0.1L83,10.3h0V13.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.9,20.3v-1.9c0-0.9,0-1.1-1-1.1v-0.2h3v0.2c-1,0-1,0.3-1,1.1v4.3c0,0.9,0,1.1,1,1.1v0.2h-3v-0.2 c1,0,1-0.3,1-1.1v-2h-3.2v2c0,0.9,0,1.1,1,1.1v0.2h-3v-0.2c1,0,1-0.3,1-1.1v-4.3c0-0.9,0-1.1-1-1.1v-0.2h3v0.2c-1,0-1,0.3-1,1.1v1.9 H48.9z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.7,21.2h1.1c0.6,0,0.9-0.1,0.9-0.8h0.1v1.8h-0.1c-0.1-0.7-0.3-0.8-0.9-0.8h-1.1v1.9c0,0.3,0.1,0.4,0.4,0.4 h1.1c0.7,0,0.9-0.3,1.4-1h0.2l-0.4,1.3h-4.1v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9v-0.1h4l0.1,1.1h-0.2 c-0.2-0.8-0.4-0.9-1.1-0.9h-1.3V21.2z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.7,22.3L57.4,23c-0.1,0.1-0.2,0.4-0.2,0.5c0,0.3,0.3,0.3,0.6,0.3v0.1h-1.6v-0.1c0.4,0,0.6-0.2,0.8-0.8 l1.9-4.4H59l1.8,4.3c0.2,0.5,0.3,0.9,0.9,0.9v0.1h-2.1v-0.1c0.3,0,0.5-0.1,0.5-0.4c0-0.2-0.1-0.4-0.2-0.6l-0.3-0.7H57.7z M58.7,19.9 L57.8,22h1.8L58.7,19.9z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.6,23c0,0.4,0,0.7,0.4,0.7h1.2c0.6,0,1-0.3,1.4-1.1l0.1,0l-0.4,1.4h-4v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2 c0-0.7,0-0.9-0.7-0.9v-0.1h2.4V19c-0.9,0-0.9,0.2-0.9,0.9V23z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.4,23.1c0,0.7,0,0.9,0.7,0.9v0.1H67v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.9h-0.8c-0.7,0-0.9,0.4-0.9,0.9h-0.1 l0.1-1.2h4.3l0.1,1.2h-0.1c0-0.5-0.2-0.9-0.9-0.9h-0.8V23.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,21.3v-1.4c0-0.7,0-0.9-0.7-0.9v-0.1H76V19c-0.7,0-0.7,0.2-0.7,0.9v3.2c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1 c0.7,0,0.7-0.2,0.7-0.9v-1.5h-2.4v1.5c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9v-0.1h2.2 V19c-0.7,0-0.7,0.2-0.7,0.9v1.4H74.5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.6,32.3c0,0.9,0,1.1,1,1.1v0.2h-3v-0.2c1,0,1-0.3,1-1.1V28c0-0.9,0-1.1-1-1.1v-0.2h2.8 c1.6,0,2.5,0.9,2.5,1.9c0,0.5-0.3,1.9-2.2,1.9c-0.4,0-0.8-0.1-1.2-0.2V32.3z M45.6,30.1c0.3,0.1,0.7,0.1,1,0.1 c0.7,0,1.2-0.7,1.2-1.5c0-0.9-0.5-1.6-1.4-1.6c-0.2,0-0.5,0-0.7,0.1V30.1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.9,31.9l-0.3,0.7c-0.1,0.1-0.2,0.4-0.2,0.5c0,0.3,0.3,0.3,0.6,0.3v0.1h-1.6v-0.1c0.4,0,0.6-0.2,0.8-0.8 l1.9-4.4h0.1l1.8,4.3c0.2,0.5,0.3,0.9,0.9,0.9v0.1h-2.1v-0.1c0.3,0,0.5-0.1,0.5-0.4c0-0.2-0.1-0.4-0.2-0.6L52,31.9H49.9z M51,29.5 l-0.9,2.1h1.8L51,29.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M58.6,30.1h-0.1c-0.2-0.9-0.8-1.5-1.8-1.5c-1.1,0-1.8,0.8-1.8,2.6c0,1.8,1.1,2.3,2,2.3c0.8,0,1.3-0.4,1.7-1.1 l0.1,0.1c-0.5,0.9-1.1,1.3-2.2,1.3c-1.5,0-2.5-1.2-2.5-2.6c0-1.5,1.1-2.8,2.7-2.8c0.4,0,0.7,0.1,1.1,0.3c0.1,0,0.2,0.1,0.2,0.1 c0.2,0,0.3-0.2,0.3-0.4h0.1L58.6,30.1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.4,32.6c0.4,0.4,0.9,0.9,1.6,0.9v0.1h-2.5v-0.1c0.2,0,0.4-0.1,0.4-0.2c0-0.2-0.2-0.4-0.3-0.5l-1.7-1.7v1.6 c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9v-0.1h2.2v0.1c-0.7,0-0.7,0.2-0.7,0.9V31 l1.3-1.2c0.2-0.2,0.7-0.7,0.7-0.9c0-0.2-0.2-0.2-0.5-0.2v-0.1h1.9v0.1c-0.5,0-1,0.5-1.4,0.8l-1.4,1.4L63.4,32.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.7,31.9l-0.3,0.7c-0.1,0.1-0.2,0.4-0.2,0.5c0,0.3,0.3,0.3,0.6,0.3v0.1h-1.6v-0.1c0.4,0,0.6-0.2,0.8-0.8 l1.9-4.4H68l1.8,4.3c0.2,0.5,0.3,0.9,0.9,0.9v0.1h-2.1v-0.1c0.3,0,0.5-0.1,0.5-0.4c0-0.2-0.1-0.4-0.2-0.6l-0.3-0.7H66.7z M67.8,29.5 l-0.9,2.1h1.8L67.8,29.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.1,33.3c-0.5,0.3-1.2,0.5-1.8,0.5c-2.3,0-2.9-1.7-2.9-2.6c0-1.2,0.9-2.8,2.8-2.8c0.4,0,0.7,0.1,1,0.2 c0.1,0,0.4,0.2,0.5,0.2c0.2,0,0.2-0.2,0.2-0.3h0.1l0.1,1.7h-0.1c-0.3-0.9-0.8-1.4-1.7-1.4c-1.3,0-1.9,1.2-1.9,2.4 c0,1.5,0.8,2.6,2,2.6c0.3,0,0.8-0.1,1.1-0.3v-1.4c0-0.7,0-0.9-0.7-0.9v-0.1h2.1V31c-0.5,0-0.6,0.2-0.6,0.7V33.3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.3,32.7c0,0.7,0,0.9,0.7,0.9v0.1h-2.2v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.2c0-0.7,0-0.9-0.7-0.9v-0.1h2.2v0.1 c-0.7,0-0.7,0.2-0.7,0.9V32.7z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.4,32.7c0,0.7,0,0.9,0.7,0.9v0.1h-1.8v-0.1c0.7,0,0.7-0.2,0.7-0.9v-3.5c-0.3-0.4-0.5-0.5-1-0.5v-0.1h1.4 l3.2,3.9h0v-2.9c0-0.7,0-0.9-0.7-0.9v-0.1h1.8v0.1c-0.7,0-0.7,0.2-0.7,0.9v4.3h-0.1l-3.4-4.2h0V32.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.7,33.3c-0.5,0.3-1.2,0.5-1.8,0.5c-2.3,0-2.9-1.7-2.9-2.6c0-1.2,0.9-2.8,2.8-2.8c0.4,0,0.7,0.1,1,0.2 c0.1,0,0.4,0.2,0.5,0.2c0.2,0,0.2-0.2,0.2-0.3h0.1l0.1,1.7h-0.1c-0.3-0.9-0.8-1.4-1.7-1.4c-1.3,0-1.9,1.2-1.9,2.4 c0,1.5,0.8,2.6,2,2.6c0.3,0,0.7-0.1,1.1-0.3v-1.4c0-0.7,0-0.9-0.7-0.9v-0.1h2.1V31c-0.5,0-0.6,0.2-0.6,0.7V33.3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.2,29.7c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3s1.3,0.6,1.3,1.3C92.5,29.1,91.9,29.7,91.2,29.7z  M91.2,27.2c-0.6,0-1.2,0.5-1.2,1.2c0,0.6,0.5,1.2,1.2,1.2c0.6,0,1.2-0.5,1.2-1.2C92.4,27.8,91.9,27.2,91.2,27.2z M90.7,28 c0-0.2,0-0.3-0.2-0.3v-0.1h0.7c0.3,0,0.6,0.1,0.6,0.4c0,0.2-0.2,0.4-0.4,0.4l0.4,0.5c0.1,0.1,0.1,0.2,0.3,0.2v0.1h-0.3l-0.5-0.7H91 V29c0,0.1,0.1,0.1,0.2,0.1v0.1h-0.7v-0.1c0.2,0,0.2-0.1,0.2-0.3V28z M91,28.4c0.2,0,0.5-0.1,0.5-0.3c0-0.2-0.2-0.3-0.4-0.3 c-0.1,0-0.1,0-0.2,0L91,28.4L91,28.4z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36,1.8c0.9,0,1.7,0.7,1.7,1.7S36.9,5.2,36,5.2c-0.9,0-1.7-0.7-1.7-1.7S35,1.8,36,1.8z M36,4.9 c0.7,0,1.4-0.6,1.4-1.4S36.7,2.1,36,2.1c-0.7,0-1.4,0.6-1.4,1.4S35.2,4.9,36,4.9z M35.4,2.5h0.7c0.4,0,0.6,0.2,0.6,0.5 c0,0.4-0.2,0.5-0.5,0.6l0.5,0.9h-0.3l-0.5-0.8h-0.3v0.8h-0.3V2.5z M35.6,3.4H36c0.3,0,0.5,0,0.5-0.3c0-0.2-0.2-0.3-0.4-0.3h-0.4V3.4 z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(1 -1.845242e-03 1.845242e-03 1 -3.617983e-02 3.627871e-02)",
    cx: 19.6,
    cy: 19.6,
    rx: 18.6,
    ry: 18.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 23.8,
    cy: 15,
    rx: 25.1,
    ry: 25.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st3",
    cx: 23.8,
    cy: 15,
    rx: 24.9,
    ry: 25.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st4",
    cx: 23.8,
    cy: 15,
    rx: 24.8,
    ry: 25.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st5",
    cx: 23.8,
    cy: 15,
    rx: 24.6,
    ry: 25.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 23.8,
    cy: 15,
    rx: 24.5,
    ry: 25
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st7",
    cx: 23.8,
    cy: 15,
    rx: 24.3,
    ry: 24.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st8",
    cx: 23.8,
    cy: 14.9,
    rx: 24.2,
    ry: 24.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 23.8,
    cy: 14.9,
    rx: 24,
    ry: 24.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st10",
    cx: 23.8,
    cy: 14.9,
    rx: 23.9,
    ry: 24.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st11",
    cx: 23.8,
    cy: 14.9,
    rx: 23.7,
    ry: 24.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 23.9,
    cy: 14.9,
    rx: 23.6,
    ry: 24.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st13",
    cx: 23.9,
    cy: 14.9,
    rx: 23.4,
    ry: 23.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st14",
    cx: 23.9,
    cy: 14.9,
    rx: 23.3,
    ry: 23.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st15",
    cx: 23.9,
    cy: 14.9,
    rx: 23.1,
    ry: 23.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st16",
    cx: 23.9,
    cy: 14.9,
    rx: 23,
    ry: 23.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st17",
    cx: 23.9,
    cy: 14.8,
    rx: 22.8,
    ry: 23.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st18",
    cx: 23.9,
    cy: 14.8,
    rx: 22.7,
    ry: 23.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st19",
    cx: 23.9,
    cy: 14.8,
    rx: 22.6,
    ry: 23
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st20",
    cx: 23.9,
    cy: 14.8,
    rx: 22.4,
    ry: 22.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st21",
    cx: 23.9,
    cy: 14.8,
    rx: 22.3,
    ry: 22.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st22",
    cx: 23.9,
    cy: 14.8,
    rx: 22.1,
    ry: 22.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st23",
    cx: 23.9,
    cy: 14.8,
    rx: 22,
    ry: 22.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st24",
    cx: 23.9,
    cy: 14.8,
    rx: 21.8,
    ry: 22.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 23.9,
    cy: 14.8,
    rx: 21.7,
    ry: 22.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st26",
    cx: 23.9,
    cy: 14.7,
    rx: 21.5,
    ry: 22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st27",
    cx: 23.9,
    cy: 14.7,
    rx: 21.4,
    ry: 21.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st28",
    cx: 23.9,
    cy: 14.7,
    rx: 21.2,
    ry: 21.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st29",
    cx: 23.9,
    cy: 14.7,
    rx: 21.1,
    ry: 21.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st30",
    cx: 23.9,
    cy: 14.7,
    rx: 20.9,
    ry: 21.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st31",
    cx: 23.9,
    cy: 14.7,
    rx: 20.8,
    ry: 21.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st32",
    cx: 23.9,
    cy: 14.7,
    rx: 20.6,
    ry: 21.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st33",
    cx: 24,
    cy: 14.7,
    rx: 20.5,
    ry: 20.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st34",
    cx: 24,
    cy: 14.7,
    rx: 20.3,
    ry: 20.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st35",
    cx: 24,
    cy: 14.6,
    rx: 20.2,
    ry: 20.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st36",
    cx: 24,
    cy: 14.6,
    rx: 20,
    ry: 20.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st37",
    cx: 24,
    cy: 14.6,
    rx: 19.9,
    ry: 20.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st38",
    cx: 24,
    cy: 14.6,
    rx: 19.8,
    ry: 20.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st39",
    cx: 24,
    cy: 14.6,
    rx: 19.6,
    ry: 20
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st40",
    cx: 24,
    cy: 14.6,
    rx: 19.5,
    ry: 19.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st41",
    cx: 24,
    cy: 14.6,
    rx: 19.3,
    ry: 19.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st42",
    cx: 24,
    cy: 14.6,
    rx: 19.2,
    ry: 19.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st43",
    cx: 24,
    cy: 14.6,
    rx: 19,
    ry: 19.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st44",
    cx: 24,
    cy: 14.6,
    rx: 18.9,
    ry: 19.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st45",
    cx: 24,
    cy: 14.5,
    rx: 18.7,
    ry: 19.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st46",
    cx: 24,
    cy: 14.5,
    rx: 18.6,
    ry: 19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st47",
    cx: 24,
    cy: 14.5,
    rx: 18.4,
    ry: 18.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st48",
    cx: 24,
    cy: 14.5,
    rx: 18.3,
    ry: 18.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st49",
    cx: 24,
    cy: 14.5,
    rx: 18.1,
    ry: 18.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st50",
    cx: 24,
    cy: 14.5,
    rx: 18,
    ry: 18.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st51",
    cx: 24,
    cy: 14.5,
    rx: 17.8,
    ry: 18.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st52",
    cx: 24,
    cy: 14.5,
    rx: 17.7,
    ry: 18
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st53",
    cx: 24,
    cy: 14.5,
    rx: 17.5,
    ry: 17.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st54",
    cx: 24.1,
    cy: 14.4,
    rx: 17.4,
    ry: 17.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st55",
    cx: 24.1,
    cy: 14.4,
    rx: 17.2,
    ry: 17.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st56",
    cx: 24.1,
    cy: 14.4,
    rx: 17.1,
    ry: 17.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st57",
    cx: 24.1,
    cy: 14.4,
    rx: 17,
    ry: 17.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st58",
    cx: 24.1,
    cy: 14.4,
    rx: 16.8,
    ry: 17.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st59",
    cx: 24.1,
    cy: 14.4,
    rx: 16.7,
    ry: 17
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st60",
    cx: 24.1,
    cy: 14.4,
    rx: 16.5,
    ry: 16.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st61",
    cx: 24.1,
    cy: 14.4,
    rx: 16.4,
    ry: 16.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st62",
    cx: 24.1,
    cy: 14.4,
    rx: 16.2,
    ry: 16.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st63",
    cx: 24.1,
    cy: 14.3,
    rx: 16.1,
    ry: 16.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st64",
    cx: 24.1,
    cy: 14.3,
    rx: 15.9,
    ry: 16.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st65",
    cx: 24.1,
    cy: 14.3,
    rx: 15.8,
    ry: 16.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st66",
    cx: 24.1,
    cy: 14.3,
    rx: 15.6,
    ry: 15.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st67",
    cx: 24.1,
    cy: 14.3,
    rx: 15.5,
    ry: 15.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st68",
    cx: 24.1,
    cy: 14.3,
    rx: 15.3,
    ry: 15.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st69",
    cx: 24.1,
    cy: 14.3,
    rx: 15.2,
    ry: 15.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st70",
    cx: 24.1,
    cy: 14.3,
    rx: 15,
    ry: 15.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st71",
    cx: 24.1,
    cy: 14.3,
    rx: 14.9,
    ry: 15.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st72",
    cx: 24.1,
    cy: 14.2,
    rx: 14.7,
    ry: 15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st73",
    cx: 24.1,
    cy: 14.2,
    rx: 14.6,
    ry: 14.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st74",
    cx: 24.2,
    cy: 14.2,
    rx: 14.4,
    ry: 14.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st75",
    cx: 24.2,
    cy: 14.2,
    rx: 14.3,
    ry: 14.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st76",
    cx: 24.2,
    cy: 14.2,
    rx: 14.2,
    ry: 14.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st77",
    cx: 24.2,
    cy: 14.2,
    rx: 14,
    ry: 14.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st78",
    cx: 24.2,
    cy: 14.2,
    rx: 13.9,
    ry: 14.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st79",
    cx: 24.2,
    cy: 14.2,
    rx: 13.7,
    ry: 14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st80",
    cx: 24.2,
    cy: 14.2,
    rx: 13.6,
    ry: 13.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st81",
    cx: 24.2,
    cy: 14.1,
    rx: 13.4,
    ry: 13.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M37.5,14.1c0,7.5-5.9,13.5-13.3,13.5c-7.3,0-13.3-6-13.3-13.5c0-7.5,5.9-13.5,13.3-13.5 C31.5,0.6,37.5,6.7,37.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M37.3,14.1c0,7.4-5.9,13.4-13.1,13.4c-7.2,0-13.1-6-13.1-13.4c0-7.4,5.9-13.4,13.1-13.4 C31.4,0.8,37.3,6.7,37.3,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M37.2,14.1c0,7.3-5.8,13.2-13,13.2c-7.2,0-13-5.9-13-13.2c0-7.3,5.8-13.2,13-13.2 C31.4,0.9,37.2,6.8,37.2,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M37,14.1c0,7.2-5.7,13.1-12.8,13.1c-7.1,0-12.8-5.8-12.8-13.1C11.4,6.9,17.1,1,24.2,1C31.3,1,37,6.9,37,14.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st86",
    d: "M36.9,14.1c0,7.1-5.7,12.9-12.7,12.9c-7,0-12.7-5.8-12.7-12.9c0-7.1,5.7-12.9,12.7-12.9 C31.2,1.2,36.9,7,36.9,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st87",
    d: "M36.7,14.1c0,7-5.6,12.8-12.5,12.8c-6.9,0-12.5-5.7-12.5-12.8c0-7,5.6-12.8,12.5-12.8 C31.1,1.3,36.7,7,36.7,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st88",
    d: "M36.6,14.1c0,7-5.5,12.6-12.4,12.6c-6.8,0-12.4-5.6-12.4-12.6c0-7,5.5-12.6,12.4-12.6 C31.1,1.5,36.6,7.1,36.6,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M36.5,14.1c0,6.9-5.5,12.4-12.2,12.4c-6.8,0-12.2-5.6-12.2-12.4c0-6.9,5.5-12.5,12.2-12.5 C31,1.6,36.5,7.2,36.5,14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st90",
    d: "M36.3,14c0,6.8-5.4,12.3-12.1,12.3c-6.7,0-12.1-5.5-12.1-12.3c0-6.8,5.4-12.3,12.1-12.3 C30.9,1.7,36.3,7.3,36.3,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M36.2,14c0,6.7-5.3,12.1-11.9,12.1c-6.6,0-11.9-5.4-11.9-12.1c0-6.7,5.3-12.1,11.9-12.1 C30.8,1.9,36.2,7.3,36.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M36,14c0,6.6-5.3,12-11.8,12c-6.5,0-11.8-5.4-11.8-12c0-6.6,5.3-12,11.8-12C30.8,2,36,7.4,36,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M35.9,14c0,6.5-5.2,11.8-11.7,11.8c-6.4,0-11.7-5.3-11.7-11.8c0-6.5,5.2-11.8,11.7-11.8 C30.7,2.2,35.9,7.5,35.9,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st94",
    d: "M35.8,14c0,6.5-5.2,11.7-11.5,11.7c-6.4,0-11.5-5.2-11.5-11.7c0-6.5,5.2-11.7,11.5-11.7 C30.6,2.3,35.8,7.5,35.8,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st95",
    d: "M35.6,14c0,6.4-5.1,11.5-11.4,11.5c-6.3,0-11.4-5.2-11.4-11.5c0-6.4,5.1-11.5,11.4-11.5 C30.5,2.5,35.6,7.6,35.6,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st96",
    d: "M35.5,14c0,6.3-5,11.4-11.2,11.4C18.1,25.4,13,20.3,13,14c0-6.3,5-11.4,11.2-11.4C30.4,2.6,35.5,7.7,35.5,14 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st97",
    d: "M35.3,14c0,6.2-5,11.2-11.1,11.2c-6.1,0-11.1-5-11.1-11.2c0-6.2,5-11.2,11.1-11.2C30.4,2.7,35.3,7.8,35.3,14 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M35.2,14c0,6.1-4.9,11.1-10.9,11.1c-6,0-10.9-5-10.9-11.1c0-6.1,4.9-11.1,10.9-11.1 C30.3,2.9,35.2,7.8,35.2,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M35,14c0,6-4.8,10.9-10.8,10.9c-5.9,0-10.8-4.9-10.8-10.9c0-6,4.8-10.9,10.8-10.9C30.2,3,35,7.9,35,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M34.9,13.9c0,6-4.8,10.8-10.6,10.8c-5.9,0-10.6-4.8-10.6-10.8c0-6,4.8-10.8,10.6-10.8 C30.1,3.2,34.9,8,34.9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M34.8,13.9c0,5.9-4.7,10.6-10.5,10.6c-5.8,0-10.5-4.8-10.5-10.6c0-5.9,4.7-10.6,10.5-10.6 C30.1,3.3,34.8,8.1,34.8,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M34.6,13.9c0,5.8-4.6,10.5-10.3,10.5c-5.7,0-10.3-4.7-10.3-10.5c0-5.8,4.6-10.5,10.3-10.5 C30,3.4,34.6,8.1,34.6,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M34.5,13.9c0,5.7-4.6,10.3-10.2,10.3c-5.6,0-10.2-4.6-10.2-10.3c0-5.7,4.6-10.3,10.2-10.3 C29.9,3.6,34.5,8.2,34.5,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M34.3,13.9c0,5.6-4.5,10.2-10,10.2c-5.5,0-10-4.6-10-10.2c0-5.6,4.5-10.2,10-10.2 C29.8,3.7,34.3,8.3,34.3,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M34.2,13.9c0,5.5-4.4,10-9.9,10c-5.5,0-9.9-4.5-9.9-10c0-5.5,4.4-10,9.9-10C29.8,3.9,34.2,8.3,34.2,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M34,13.9c0,5.5-4.4,9.9-9.7,9.9c-5.4,0-9.7-4.4-9.7-9.9c0-5.5,4.4-9.9,9.7-9.9C29.7,4,34,8.4,34,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M33.9,13.9c0,5.4-4.3,9.7-9.6,9.7c-5.3,0-9.6-4.4-9.6-9.7c0-5.4,4.3-9.7,9.6-9.7 C29.6,4.1,33.9,8.5,33.9,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M33.8,13.9c0,5.3-4.2,9.6-9.4,9.6c-5.2,0-9.4-4.3-9.4-9.6c0-5.3,4.2-9.6,9.4-9.6 C29.5,4.3,33.8,8.6,33.8,13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M33.6,13.8c0,5.2-4.2,9.4-9.3,9.4c-5.1,0-9.3-4.2-9.3-9.4c0-5.2,4.2-9.4,9.3-9.4 C29.5,4.4,33.6,8.6,33.6,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M33.5,13.8c0,5.1-4.1,9.3-9.1,9.3c-5.1,0-9.1-4.2-9.1-9.3c0-5.1,4.1-9.3,9.1-9.3 C29.4,4.6,33.5,8.7,33.5,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M33.3,13.8c0,5-4,9.1-9,9.1c-5,0-9-4.1-9-9.1c0-5,4-9.1,9-9.1C29.3,4.7,33.3,8.8,33.3,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M33.2,13.8c0,5-4,9-8.9,9c-4.9,0-8.9-4-8.9-9c0-5,4-9,8.9-9C29.2,4.8,33.2,8.9,33.2,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M33,13.8c0,4.9-3.9,8.8-8.7,8.8c-4.8,0-8.7-3.9-8.7-8.8c0-4.9,3.9-8.8,8.7-8.8C29.1,5,33,8.9,33,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M32.9,13.8c0,4.8-3.8,8.7-8.6,8.7c-4.7,0-8.6-3.9-8.6-8.7c0-4.8,3.8-8.7,8.6-8.7C29.1,5.1,32.9,9,32.9,13.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M32.8,13.8c0,4.7-3.8,8.5-8.4,8.5c-4.6,0-8.4-3.8-8.4-8.5c0-4.7,3.8-8.5,8.4-8.5C29,5.3,32.8,9.1,32.8,13.8 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M32.6,13.8c0,4.6-3.7,8.4-8.3,8.4c-4.6,0-8.3-3.7-8.3-8.4c0-4.6,3.7-8.4,8.3-8.4 C28.9,5.4,32.6,9.1,32.6,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M32.5,13.8c0,4.5-3.6,8.2-8.1,8.2c-4.5,0-8.1-3.7-8.1-8.2c0-4.5,3.6-8.2,8.1-8.2 C28.8,5.5,32.5,9.2,32.5,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M32.3,13.7c0,4.5-3.6,8.1-8,8.1c-4.4,0-8-3.6-8-8.1c0-4.5,3.6-8.1,8-8.1C28.8,5.7,32.3,9.3,32.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M32.2,13.7c0,4.4-3.5,7.9-7.8,7.9c-4.3,0-7.8-3.5-7.8-7.9c0-4.4,3.5-7.9,7.8-7.9 C28.7,5.8,32.2,9.4,32.2,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M32,13.7c0,4.3-3.4,7.8-7.7,7.8c-4.2,0-7.7-3.5-7.7-7.8c0-4.3,3.4-7.8,7.7-7.8C28.6,6,32,9.4,32,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M31.9,13.7c0,4.2-3.4,7.6-7.5,7.6c-4.2,0-7.5-3.4-7.5-7.6c0-4.2,3.4-7.6,7.5-7.6 C28.5,6.1,31.9,9.5,31.9,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M31.8,13.7c0,4.1-3.3,7.5-7.4,7.5c-4.1,0-7.4-3.3-7.4-7.5c0-4.1,3.3-7.5,7.4-7.5 C28.5,6.2,31.8,9.6,31.8,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M31.6,13.7c0,4-3.2,7.3-7.2,7.3c-4,0-7.2-3.3-7.2-7.3c0-4,3.2-7.3,7.2-7.3C28.4,6.4,31.6,9.7,31.6,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M31.5,13.7c0,4-3.2,7.2-7.1,7.2c-3.9,0-7.1-3.2-7.1-7.2c0-4,3.2-7.2,7.1-7.2C28.3,6.5,31.5,9.7,31.5,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M31.3,13.7c0,3.9-3.1,7-6.9,7c-3.8,0-6.9-3.1-6.9-7c0-3.9,3.1-7,6.9-7C28.2,6.7,31.3,9.8,31.3,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M31.2,13.7c0,3.8-3,6.9-6.8,6.9c-3.8,0-6.8-3.1-6.8-6.9c0-3.8,3-6.9,6.8-6.9C28.2,6.8,31.2,9.9,31.2,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M31,13.6c0,3.7-3,6.7-6.6,6.7c-3.7,0-6.6-3-6.6-6.7c0-3.7,3-6.7,6.6-6.7C28.1,6.9,31,9.9,31,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M30.9,13.6c0,3.6-2.9,6.6-6.5,6.6c-3.6,0-6.5-2.9-6.5-6.6c0-3.6,2.9-6.6,6.5-6.6C28,7.1,30.9,10,30.9,13.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M30.8,13.6c0,3.5-2.8,6.4-6.3,6.4c-3.5,0-6.3-2.9-6.3-6.4c0-3.5,2.8-6.4,6.3-6.4 C27.9,7.2,30.8,10.1,30.8,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M30.6,13.6c0,3.5-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.5,2.8-6.2,6.2-6.2 C27.8,7.4,30.6,10.2,30.6,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M30.5,13.6c0,3.4-2.7,6.1-6.1,6.1c-3.3,0-6.1-2.7-6.1-6.1c0-3.4,2.7-6.1,6.1-6.1 C27.8,7.5,30.5,10.2,30.5,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M30.3,13.6c0,3.3-2.6,5.9-5.9,5.9c-3.3,0-5.9-2.7-5.9-5.9c0-3.3,2.6-5.9,5.9-5.9 C27.7,7.6,30.3,10.3,30.3,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st133",
    d: "M30.2,13.6c0,3.2-2.6,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.8c0-3.2,2.6-5.8,5.8-5.8 C27.6,7.8,30.2,10.4,30.2,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st134",
    d: "M30.1,13.6c0,3.1-2.5,5.6-5.6,5.6c-3.1,0-5.6-2.5-5.6-5.6c0-3.1,2.5-5.6,5.6-5.6 C27.5,7.9,30.1,10.5,30.1,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st135",
    d: "M29.9,13.6c0,3-2.4,5.5-5.5,5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.4-5.5,5.5-5.5C27.5,8.1,29.9,10.5,29.9,13.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st136",
    d: "M29.8,13.5c0,2.9-2.4,5.3-5.3,5.3c-2.9,0-5.3-2.4-5.3-5.3c0-2.9,2.4-5.3,5.3-5.3 C27.4,8.2,29.8,10.6,29.8,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st137",
    d: "M29.6,13.5c0,2.9-2.3,5.2-5.2,5.2c-2.9,0-5.2-2.3-5.2-5.2c0-2.9,2.3-5.2,5.2-5.2 C27.3,8.3,29.6,10.7,29.6,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st138",
    d: "M29.5,13.5c0,2.8-2.2,5-5,5c-2.8,0-5-2.3-5-5c0-2.8,2.2-5,5-5C27.2,8.5,29.5,10.7,29.5,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st139",
    d: "M29.3,13.5c0,2.7-2.2,4.9-4.9,4.9c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9 C27.2,8.6,29.3,10.8,29.3,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st140",
    d: "M29.2,13.5c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7c0-2.6,2.1-4.7,4.7-4.7 C27.1,8.8,29.2,10.9,29.2,13.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st141",
    d: "M29.1,13.5c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6c0-2.5,2.1-4.6,4.6-4.6C27,8.9,29.1,11,29.1,13.5z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st142",
    d: "M28.9,13.5c0,2.4-2,4.4-4.4,4.4c-2.4,0-4.4-2-4.4-4.4C20,11,22,9,24.5,9C26.9,9,28.9,11,28.9,13.5z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9,
    y: 18.7,
    className: "st143",
    width: 38.1,
    height: 1.9
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st143",
    points: "4.8,31.1 14.8,5.4 24.3,5.4 33.5,28.1 16.1,28.1 16.1,22.6 22.7,22.6 19.1,11.3 11.4,33.7 5.3,33.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhpLogo);
export default __webpack_public_path__ + "static/media/ahp_logo.6fe4016e3c232ae909f9cc8f09e84773.svg";
export { ForwardRef as ReactComponent };